import React from 'react';

export const PerkTransactionSection = ({trans, sectionHead}) => {
    return (
        <tr key={trans.id} style={{backgroundColor: 'rgba(238, 241, 243, 1)'}} >
            {/* <td style={{padding: 20}}><Checkbox onChange={() => onTransactionSelect(trans.id, trans.selected, sectionHead)} checked={trans.selected} value={trans.id}/></td> */}
            <td style={{padding: 20}}>
                {trans.date}
            </td>
            <td style={{padding: 20}}>
                {trans.merchant.length > 40 ? trans.merchant.slice(0,38) + "..." : trans.merchant}
            </td>
            <td style={{padding: 20}}>
                {trans.category}
            </td>
            <td style={{padding: 20}}>
                $ {(trans.amount/100).toFixed(2)}
            </td>
        </tr>
    );
};